<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <SearchInspIndexForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SearchInspIndexForm from '@/components/organisms/terminal/form/SearchInspIndexForm'

export default {
  name: 'SearchInspIndexPage',

  components: {
    SearchInspIndexForm,
  },
}
</script>
